import type { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import type { ButtonProps } from '@hdir/ui/button';

import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '../Button';
import React from 'react';
import { FontAwesomeIconWrapper } from '../../components/FontAwesomeIconWrapper';
import { Span, cn } from '../Element';


export type ToggleButtonProps = ButtonProps & {
	error?: boolean;
	icon?: IconDefinition;
	iconColor?: FontAwesomeIconProps['color'];
	label: string;
	pressed: boolean;
};


export const ToggleButton = ({
	disabled,
	error,
	iconColor,
	icon,
	label,
	// multiple = false,
	onClick,
	pressed,
	...otherProps
}: ToggleButtonProps): React.JSX.Element => {
	const waiAttributes: Record<string, boolean|string|undefined> = {
		'data-state': pressed ? 'on' : 'off',
	};
	waiAttributes['role'] = 'radio';
	waiAttributes['aria-checked'] = pressed;
	return (
		<Span
			boxShadow={error ? 'after:insetRingMdError' : undefined}
			className={[
				"after:content-['']",
				'after:absolute',
				'after:inset-0',
				'after:pointer-events-none',
				'after:z-10',
				'relative',
			]}
		>
			<Button
				{...otherProps}
				{...waiAttributes}
				className={cn({
					bgColor: pressed ? 'surfaceFeedbackSuccessDefaultImportant': undefined,
					boxShadow: pressed ? 'ariaCheckedButtonSelected' : undefined,
					className: 'rounded-sm',
					padding: { all: 'md' },
					weight: pressed ? 'semiBold' : undefined,
				})}
				disabled={disabled}
				onClick={onClick}
				variant='secondary'
			>
				{pressed ? <FontAwesomeIconWrapper icon={faCheck}/> : null}
				{/* Some icons look bad in 16px, scale helps */}
				{icon ? <FontAwesomeIconWrapper className={`scale-125 ${iconColor}`} icon={icon}/> : null}
				{label}
			</Button>
		</Span>
	);
};
